import React from 'react';
import CreateContribution from '../components/CreateContribution';

const CreateContributionPage: React.FC = () => {
  const content = (
    <> 
      <CreateContribution />
    </>
  );

  return content;
};

export default CreateContributionPage;
